<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>质量监控</el-breadcrumb-item>
			<el-breadcrumb-item>颜色监控</el-breadcrumb-item>
		</el-breadcrumb>
		<ToolBar v-on:select="handleSelectJT"></ToolBar>
		<div class="monitor_section" v-if="showDeviceInfo">
			<div slot="header" class="clearfix" style="margin-bottom:20px;">
				<span>颜色监控</span>
				<el-button style="float: right; padding: 3px 0" type="text" @click="handleFullScreen('defect_view')">最大化</el-button>
			</div>
			<device-color-status :class="{ view: istrue }" id="defect_view" :jt_id="selectedJT._id.$oid" :jt_status="selectedJT.statusInfo" />
		</div>
	</div>
</template>

<script>
	import DeviceColorStatus from '../public/DeviceColorStatus'
	import ToolBar from './ToolBar'
	import maxwindous from './maxWindous.js'

	export default {
		mixins: [maxwindous],
		components: {
			DeviceColorStatus,
			ToolBar,
		},
		data() {
			return {
				showDeviceInfo: false,
				selectedJT: {},
			}
		},
		methods: {
			/**
			 * 查看机台状态。
			 */
			handleSelectJT(jt) {
				this.showDeviceInfo = true
				this.selectedJT = jt

				console.log('查看机台状态。', jt)
			},
		},
	}
</script>

<style scoped>
	.view {
		background-color: #fff;
		/* margin: 50px; */
		padding: 15% 20px;
	}
</style>
